import ServiceBase from '../../ServiceBase';
import corporateProxy from './../../../proxies/market/market-calendar/CorporateProxy';

class CorporateService extends ServiceBase {
  getListDataErnCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getListDataErnCorporate',
      formatParams,
    )(() => corporateProxy.getCorporateEaring(formatParams));
  }

  getListDataDivCashCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getListDataDivCashCorporate',
      formatParams,
    )(() => corporateProxy.getCorporateCashDividend(formatParams));
  }

  getListDataDivStockCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getListDataDivStockCorporate',
      formatParams,
    )(() => corporateProxy.getCorporateStockDividend(formatParams));
  }

  getListDataSisCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getCorporateShareIssuance',
      formatParams,
    )(() => corporateProxy.getCorporateShareIssuance(formatParams));
  }

  getListDataIpoCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getCorporateIPO',
      formatParams,
    )(() => corporateProxy.getCorporateIPO(formatParams));
  }

  getListDataLisCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getCorporateLIS',
      formatParams,
    )(() => corporateProxy.getCorporateLIS(formatParams));
  }

  getListDataAgmCorporate(formatParams) {
    return this.applyMemoryCache(
      'CorporateService.getCorporateAGM',
      formatParams,
    )(() => corporateProxy.getCorporateAGM(formatParams));
  }
}

const corporateService = new CorporateService();
export default corporateService;
